import type { ColumnDef } from '@tanstack/react-table';

import { type GetTotemsFilterQuery, TotemState, TotemType } from 'data/__generated__';
import { textColumn, numberColumn, multiSelectColumn } from 'components/DataTable';

import { StatusTag } from 'pages/Organizations/OrganizationDetails/TotemsDetails/StatusTag';
import { TOTEMS_STATES_LABELS } from 'pages/Organizations/OrganizationDetails/TotemsDetails/constants/states';

export type TotemRow = GetTotemsFilterQuery['totemsFilter']['totems'][number];

export type TotemFilterInput = {
    searchValue: string;
    state: TotemState[];
};

export const totemsColumns: ColumnDef<TotemRow, unknown>[] = [
    textColumn<TotemRow, TotemFilterInput>({
        accessorKey: 'name',
        header: 'Nom',
        filterKey: 'searchValue',
        defaultVisible: true,
    }),
    numberColumn<TotemRow, TotemFilterInput>({
        accessorKey: 'number',
        header: 'Numéro',
        defaultVisible: true,
    }),
    {
        id: 'organizationName',
        header: 'Organisation',
        meta: { defaultVisible: true },
        accessorFn: (row) => row.organization.name,
        cell: ({ row }) => row.original.organization.name,
    },
    {
        id: 'type',
        header: 'Type',
        meta: { defaultVisible: true },
        accessorFn: (row) => row.type,
        cell: ({ row }) => row.original.type as TotemType,
    },
    multiSelectColumn<TotemRow, TotemFilterInput>({
        accessorKey: 'state',
        header: 'Statut',
        filterKey: 'state',
        defaultVisible: true,
        options: Object.values(TotemState).map((state) => ({
            value: state,
            label: TOTEMS_STATES_LABELS[state] ?? state,
        })),
        renderOption: (option) => <StatusTag state={option.value as TotemState} />,
        cell: ({ row }) => <StatusTag state={row.original.state} />,
    }),
    {
        id: 'sites',
        header: 'Sites',
        meta: { defaultVisible: true },
        cell: ({ row }) => {
            const count = row.original.sites.length;
            if (count === 0) {
                return <span className="text-muted-foreground">—</span>;
            }
            return <span>{count}</span>;
        },
    },
];
